/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingUserConfig } from '../../config/loading.config';
export interface ILoadingUserPluginMethods extends IPluginMethodMap {
  getLoadingUserSync(args?: any): any;
}

export class LoadingUserPlugin implements IAgentPlugin {
  readonly methods: ILoadingUserPluginMethods;

  constructor() {
    this.methods = {
      getLoadingUserSync: this.getLoadingUserSync.bind(this),
    };
  }

  getLoadingUserSync(args?: any) {
    return {
      loading: loadingUserConfig,
    };
  }
}
